import { ErrorHandler, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { LoaderService } from '../services/loader.service';
import { DialogService } from '../../shared/services/dialog.service';
import { DialogType, ToastType } from '../../shared/shared.model';
import { Router } from '@angular/router';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private loaderService: LoaderService,
    private dialogService: DialogService,
    private router: Router
  ) {}

  handleError(error: Error | HttpErrorResponse) {
    this.loaderService.hideLoader();
    if (error instanceof HttpErrorResponse) {
      // Server error
      console.log('server error', error);
      if (error.status == 401) {
        this.dialogService.openDialog({
          text: `You have been logged out. Please log in again to continue.`,
          title: 'Login required',
          dialogType: DialogType.Alert,
          onClick: () => {
            window.location.href = '/';
          }
        });
        return;
      }
      if (error.status == 403) {
        this.router.navigate(['/acess-denied']);
        return;
      }
      this.dialogService.openToast({
        message: 'Oops!Something went wrong.',
        toastType: ToastType.Error
      });
    } else {
      // Client error
      console.log('Client error', error);
    }
  }
}
